module.exports = __webpack_public_path__ + "static/media/owen_headshot.3f6c9599.png";